export const newsLang = {
    news: {
        'en': 'NEWS',
        'fr': 'ACTUALITÉS',
        'de': 'NEWS',
        'ko': '소식',
        'ch': '新闻',
        'ru': 'НОВОСТИ'
    },
}